import React, { useEffect, useState } from "react";
import { usePhrase } from "@/contexts/LanguageContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";

const CATEGORIES = ["Lender did not contact","Unauthorized data sharing","Incorrect application status","Misleading offer","Unauthorized fee","Facilitator conduct","Document problem","Scheme information issue","Technical issue","Account or privacy issue","Other"];

export default function Grievances() {
  const pt = usePhrase();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ category: CATEGORIES[0], description: "", priority: "Medium" });
  const load = async () => setItems((await api.get("/grievances")).data);
  useEffect(() => { load(); }, []);

  const submit = async () => {
    try { await api.post("/grievances", form); toast.success(pt("Grievance filed")); setForm({ ...form, description: "" }); await load(); } catch (e) { toast.error(pt("Failed")); }
  };

  return (
    <div className="space-y-6" data-testid="grievances-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 brand-heading">{pt("Grievances")}</h1>
        <p className="text-slate-600 mt-1 text-sm">{pt("Report platform, lender or scheme-related issues.")}</p>
      </div>
      <div className="p-6 rounded-lg border border-slate-200 bg-white">
        <h2 className="font-semibold text-slate-900 brand-heading">{pt("File a grievance")}</h2>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="text-sm font-medium text-slate-800">{pt("Category")}</label>
            <select data-testid="griev-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2">
              {CATEGORIES.map((c) => <option key={c} value={c}>{pt(c)}</option>)}
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-slate-800">{pt("Priority")}</label>
            <select data-testid="griev-priority" value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2">
              {["Low", "Medium", "High"].map((c) => <option key={c} value={c}>{pt(c)}</option>)}
            </select>
          </div>
        </div>
        <label className="text-sm font-medium text-slate-800 mt-3 block">{pt("Description")}</label>
        <textarea rows={4} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="griev-desc" className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2" />
        <button onClick={submit} data-testid="griev-submit" className="mt-4 rounded-md bg-slate-900 hover:bg-slate-800 text-white px-5 py-2.5 text-sm font-semibold">{pt("File grievance")}</button>
      </div>

      <div className="p-6 rounded-lg border border-slate-200 bg-white">
        <h2 className="font-semibold text-slate-900 brand-heading mb-3">{pt("My tickets")}</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200">
              <tr><th className="py-2 pr-3">{pt("Ticket")}</th><th className="py-2 pr-3">{pt("Category")}</th><th className="py-2 pr-3">{pt("Priority")}</th><th className="py-2 pr-3">{pt("Status")}</th></tr>
            </thead>
            <tbody>
              {items.map((g) => (
                <tr key={g.id} className="border-b border-slate-100" data-testid={`griev-${g.id}`}>
                  <td className="py-2 pr-3 font-mono">{g.ticket_number}</td>
                  <td className="py-2 pr-3">{pt(g.category)}</td>
                  <td className="py-2 pr-3">{pt(g.priority)}</td>
                  <td className="py-2 pr-3"><span className="rounded-full bg-slate-100 border border-slate-200 px-2 py-0.5 text-xs">{pt(g.status)}</span></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={4} className="py-6 text-center text-slate-500">{pt("No grievances filed yet.")}</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
